if (typeof(StorageProducts) === 'undefined') {
    class StorageProducts extends HTMLElement{
        constructor(){
            super();

            this.list = this.querySelector('ul');
            this.skeletonHtml = this.list.innerHTML
            this.inCart = [];
            this.pagination = this.querySelector('.pagination')
            this.currentPage = 1
        }

        setVars(key, section, list){
            this.storageKey = key;
            this.section = section;
            this.list = list;
        }

        init(reloaded = false){
            if(document.querySelector('cart-items')){
                this.inCart = Array.from(document.querySelectorAll('.cart-item')).map(item => {
                    return item.getAttribute('data-product');
                })
            }

            this.getProducts()
                .then(async products => {
                    this.products = products.filter(product => {
                        return !this.inCart.some(cartProductHandle => cartProductHandle === product.handle)
                    })
                    if(this.products.length == 0){
                        throw new Error('no products found')
                    }
                    this.querySelector('h3').style.display = 'block';
                    this.list.style.display = 'flex';
                    await this.renderProductCards();
                    // enable pagination if needed
                    if(this.list.scrollWidth > this.list.clientWidth){
                        this.setupPagination()
                    }
                    this.list.removeAttribute('data-loading');
                })
                .catch((err) => {
                    if(err.message == 'no products found'){
                        this.list.style.display = 'none';
                        if(this.list.parentNode){
                            this.list.parentNode.style.display = 'none';
                        }
                    }else{
                        console.error(err)
                    }
                })
        }

        setupPagination(){
            this.pagination.style.display = 'flex';
            this.perPage = 0;
            this.list.querySelectorAll('li').forEach(li => {
                if(li.getBoundingClientRect().right <= this.list.getBoundingClientRect().right){
                    this.perPage++;
                }
            })
            this.totalPages = Math.ceil(this.list.querySelectorAll('li').length / this.perPage);

            this.pagination.querySelector('.previous').addEventListener('click', this.scrollProducts.bind(this, 'previous'))
            this.pagination.querySelector('.next').addEventListener('click', this.scrollProducts.bind(this, 'next'))
        }

        scrollProducts(direction){
            if(direction == 'next'){
                if(this.currentPage < this.totalPages){
                    this.pagination.querySelector('.previous').removeAttribute('disabled')
                    this.currentPage++;
                }
            }else{
                if(this.currentPage > 1){
                    this.pagination.querySelector('.next').removeAttribute('disabled')
                    this.currentPage--;
                }
            }
            
            const scrollLeft = (this.list.querySelector('li').offsetWidth + 24) * (this.perPage * (this.currentPage - 1));
            this.list.scrollTo({left: scrollLeft, top: 0, behavior: 'smooth'})
            
            if(direction == 'next'){
                if(this.currentPage == this.totalPages){
                    this.pagination.querySelector('.next').setAttribute('disabled', 'disabled')
                }
            }else{
                if(this.currentPage == 1){
                    this.pagination.querySelector('.previous').setAttribute('disabled', 'disabled')
                }
            }
        }

        rerender(){
            //this.list.querySelectorAll('li').forEach(li => li.remove())
            this.list.innerHTML = this.skeletonHtml;
            this.init(true);
        }

        getProducts(){
            return new Promise((resolve, reject) => {
                if(!window.localStorage){
                    reject(new Error('no products found'));
                }
                let products = localStorage.getItem(this.storageKey)
                if(!products){
                    reject(new Error('no products found'));
                }
                products = JSON.parse(products)
                if(this.section === 'wishlist'){
                    products = products?.all
                }
                if(products && Array.isArray(products) && products.length > 0){
                    if(this.section === 'wishlist'){
                        products = products.map(handle => {
                            return {
                                handle: `${handle.du.substr(handle.du.lastIndexOf('/') + 1)}`,
                                time: handle.uts
                            }
                        })
                    }
                    if(this.section == 'views'){
                        var today = new Date();
                        var month_ago = new Date(new Date().setDate(today.getDate() - 30));
                        products = products.filter(product => {
                            return product.time >= month_ago.getTime()
                        })
                    }
                    resolve(products)
                }else{
                    reject(new Error('no products found'));
                }
            })
        }

        getSectionInnerHTML(html, selector) {
            return new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector(selector).innerHTML;
        }

        renderProductCards(){
            return new Promise((resolve, reject) => {
                const promises = [];
                const timestamps = this.products.map(({handle, time}, index) => {
                    const productCard = fetch(`/products/${handle}${(handle.indexOf('?') == -1) ? '?' : '&'}sections=product-card`)
                        .then(response => response.json())
                    promises.push(productCard)
                    return {
                        time,
                        index
                    }
                })
    
                timestamps.sort((a, b) => {
                    return b.time - a.time
                })
    
                Promise.all(promises)
                    .then(productSections => {
                        this.list.querySelectorAll('.skeleton').forEach(skeleton => {
                            skeleton.remove()
                        })
                        timestamps.forEach(({index}) => {
                            const html = this.getSectionInnerHTML(productSections[index]['product-card'], '#shopify-section-product-card');
                            if(html !== 'undefined'){
                                this.list.insertAdjacentHTML('beforeend', html);
                            }
                        })
                        resolve()
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }

        removeItem(handle){
            if(this.list.querySelector(`li[data-product="${handle}"]`)){
                this.list.querySelector(`li[data-product="${handle}"]`).remove()
                if(this.list.querySelectorAll('li').length === 0){
                    this.list.style.display = 'none';
                    this.list.innerHTML = this.skeletonHtml;
                    this.querySelector('h3').style.display = 'none';
                }
            }
        }
    }

    if (!customElements.get('recently-viewed')) {
        class RecentlyViewed extends StorageProducts{
            constructor(){
                super();
                this.setVars('vipstore-recently-viewed-products', 'views', this.querySelector('ul'))
                this.init();
            }
        }
        customElements.define('recently-viewed', RecentlyViewed);
    }
    
    if (!customElements.get('wishlist-products')) {
        class Wishlist extends StorageProducts{
            constructor(){
                super();
                this.setVars('swym-products', 'wishlist', this.querySelector('ul'))
                this.init();
            }
        }
        customElements.define('wishlist-products', Wishlist);
    }
}
